export default __webpack_public_path__ + "static/media/img-count-3-line@2x.abacfb07.png";